import { useEffect, useState } from "react";
import chatSocketService from "../../../services/websocket";
import { sendEmojiReaction, listenToEmojiReactions } from "../../../services/socketChatService";

// Custom Hook: useEmojiReactions
export const useEmojiReactions = (venueUUID, currentUser) => {
  const [incomingReactions, setIncomingReactions] = useState([]);

  useEffect(() => {
    if (!venueUUID || !chatSocketService.connected) {
      setIncomingReactions([]);
      return;
    }

    const unsubscribe = listenToEmojiReactions(
      venueUUID,
      (reactions, error) => {
        if (error) {
          console.error("Emoji reactions dinleme hatası:", error);
          return;
        }

        console.log("🎯 Hook'a gelen emoji reactions:", reactions);
        console.log("🎯 Current user ID:", currentUser?.id);

        // Sadece başka kullanıcılardan gelen reaction'ları işle
        const otherUsersReactions = reactions.filter(
          (reaction) => reaction.senderId !== currentUser?.id
        );

        console.log("🎯 Filtrelenmiş emoji reactions:", otherUsersReactions);
        setIncomingReactions(otherUsersReactions);
      }
    );

    return () => unsubscribe();
  }, [venueUUID, currentUser?.id]);

  const sendReaction = async (emoji) => {
    if (!venueUUID || !currentUser || !chatSocketService.connected) {
      throw new Error("Bağlantı yok veya kullanıcı bilgisi eksik");
    }

    try {
      const sender = {
        id: currentUser.id,
        name: currentUser.name,
        avatar: currentUser.avatar,
      };

      await sendEmojiReaction(venueUUID, sender, emoji);
    } catch (error) {
      console.error("Emoji reaction gönderme hatası:", error);
      throw error;
    }
  };

  return { incomingReactions, sendReaction };
}; 